import { Component } from "react";

import { mergeClassNames } from "@bokio/utils/classes";

import type { PropsWithChildren } from "react";

import * as styles from "./table.scss";

export interface TFootProps {
	className?: string;
}

class TFoot extends Component<PropsWithChildren<TFootProps>> {
	render() {
		return <tfoot className={mergeClassNames(this.props.className, styles.tfoot)}>{this.props.children}</tfoot>;
	}
}

export default TFoot;
